import { apiLink } from '../../constants/env';
import axiosInstance from '../AxiosInstance';

const apiBombasVacuo = {
    fetchApi: async (page) => {
        const URL = `${apiLink()}api/bomba-vacuo?page=` + page;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
            })
    },
    postApi: async (bomba) => {
        const URL = `${apiLink()}api/bomba-vacuo`;
        return await axiosInstance.post(URL, bomba)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao fazer o post dos dados:', error);
                throw new Error(error);
            })
    },
    putApi: async (id, bomba) => {
        const URL = `${apiLink()}api/bomba-vacuo/${id}`;
        return await axiosInstance.put(URL, bomba)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao fazer o post dos dados:', error);
                throw new Error();

            })
    },
    deleteApi: async (id) => {
        const URL = `${apiLink()}api/bomba-vacuo/status/${id}`;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao deletar o Bomba:', error);
                throw new Error();

            })
    },
    findAll: async (id) => {
        const URL = `${apiLink()}api/bomba-vacuo/all`;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao pegar unidade da bomba:', error);
                throw new Error();

            })
    },
    getEquipamentoComUltimasLeituras: async (equipamentoId, numLeituras) => {
        const URL = `${apiLink()}api/bomba-vacuo/${equipamentoId}/numero-leituras/${numLeituras}`;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao pegar bomba:', error);
                throw new Error('Erro ao pegar bomba:', error);
            })
    }

}

export default apiBombasVacuo; 